<template>
  <main class="target-wallet">
    <template v-if="extension.payload && extension.payload.target_wallet">
      <div class="offer offer-name">
        <div class="offer-label">target</div>
        <div class="offer-value">{{ extension.payload.target_wallet }}</div>
      </div>
    </template>
  </main>
</template>

<script>
export default {
  props: {
    extension: Object
  },

  name: "target-wallet-preview"
}
</script>

<style scoped>
.target-wallet {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}

.target-wallet .offer{
  overflow: hidden;
  padding: 0 6px;
}

.target-wallet .offer-label {
  color: gray;
  font-size: 1em;
}

.target-wallet .offer-value {
  font-size: 1.5em;
}
</style>
